import React from "react"

const ArticleContext = React.createContext();

export default ArticleContext